import { Loader } from "@adeccoux/tag-ds";
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
    fetchQuestionTest28,
    getFocusAndMultitaskingTest,
} from "../../util/resources";
import SesHeader from "../header";
import { nextUrl } from "./qNavigations";
import ReadyToStart from "./readyToStart";
import DisplayButton from "../../util/displaybutton";

const Instructions = () => {
    const [test28Data, setTest28Data] = useState();
    const [loading, setLoading] = useState(true);
    const [interstitialShown, setInterstitialShown] = useState(false);
    const clientCobranding = sessionStorage.getItem("clientLogo");
    const phrases = JSON.parse(sessionStorage.getItem("phrases"));
    const testData = JSON.parse(sessionStorage.getItem("test_details"));
    const sessionId = JSON.parse(
        sessionStorage.getItem("session_data")
    )?.sessionId;
    const testId = JSON.parse(sessionStorage.getItem("test"))?.id;
    const navigate = useNavigate();
    const location = useLocation();

    const tt37Data = useRef();

    const setAssesmentDisable = () => {
        if (
            location.state.test.testExample !== null &&
            !location.state.samplesCompleted &&
            !location.state.test.samplesCompleted &&
            location.state.test.exampleMandatory
        ) {
            return true;
        }
        return false;
    };

    const handleButtonClick = (warmUp) => {
        const nextURL = nextUrl(location.state.test.testType);
        navigate(nextURL, {
            state: {
                ...location.state,
                warmUp,
                ...(location.state.test28Data
                    ? {
                        test28Data: location.state.test28Data,
                    }
                    : {
                        test28Data: test28Data,
                    }),
                samplesCompleted: false,
                data: tt37Data.current,
                ...(tt37Data.current && {
                    isExample: warmUp ? true : false,
                }),
                restartWarmUp: null,
                startMainTest: null,
            },
        });
    };

    const handleStart = () => {
        if ([9, 37].includes(location.state.test.testType)) {
            handleButtonClick(false);
        } else {
			if(location.state.previewData){
                setInterstitialShown(false);
                handleButtonClick();
            }else{
                setInterstitialShown(true);
            }
        }
    };

    useEffect(() => {
        const getTestData = async () => {
            if (
                location.state.test.testType == 28 ||
                location.state.test.testType == 29
            ) {
                const response = await fetchQuestionTest28(testId, sessionId);
                setTest28Data(response.data);
                setLoading(false);
            } else if (location.state.test.testType == 37) {
                const response = await getFocusAndMultitaskingTest(
                    testId,
                    sessionId,
                    location.state.samplesCompleted
                );
                location.state.test = response.data;
                location.state.samplesCompleted =
                    response.data.exampleAttempted;
                tt37Data.current = response.data;
                window.sessionStorage.setItem(
                    "sessionId",
                    location.state.user.sessionId
                );
                window.sessionStorage.setItem("testId", testId);
                window.sessionStorage.setItem(
                    "currentMeterNumber",
                    response.data.currentMeter
                );
                window.sessionStorage.setItem(
                    "currentMeterValue",
                    response.data.currentMeterVal
                );
                window.sessionStorage.setItem(
                    "callbackUrl",
                    response.data.urlProvider
                );
                setLoading(false);
            }
            if (
                location.state.previewData ||
                ([9, 37].includes(location.state.test.testType) &&
                    location.state.test?.status?.id === 4)
            ) {
                if(!location?.state?.fullTestPreview){
                    handleButtonClick();
                }
            } else if (location.state.test?.status?.id === 4) {
                setInterstitialShown(true);
            }
            if (location.state?.restartWarmUp) {
                handleButtonClick(true);
            }
            if (location.state?.startMainTest) {
                handleButtonClick(false);
            }
        };
        getTestData();
    }, []);

    return (
        <>
            {((location.state.test.testType == 28 ||
                location.state.test.testType == 37) &&
                loading) ||
                location.state?.restartWarmUp ? (
                <Loader
                    className="align-items_start justify-content_center mt5"
                    spinner
                    title="Hold on a sec..."
                />
            ) : (
                <>
                    {interstitialShown ? (
                        <ReadyToStart
                            setInterstitialShown={setInterstitialShown}
                            handleButtonClick={handleButtonClick}
                        />
                    ) : (
                        <>
                            <SesHeader
                                clientCobranding={
                                    clientCobranding ? clientCobranding : false
                                }
                                isWarmUp={false}
                            />
                            <div className="h3">{phrases?.["14261"]}</div>
                            <div className="mt2">
                                {location.state.test.testType == 28 ||
                                    location.state.test.testType == 37 ? (
                                    <div
                                        style={{
                                            whiteSpace: "pre",
                                            textWrap: "wrap",
                                        }}
                                        dangerouslySetInnerHTML={{
                                            __html:
                                                test28Data?.instruction ||
                                                tt37Data.current
                                                    ?.instructionsTemplate,
                                        }}
                                    />
                                ) : (
                                    <div
                                        dangerouslySetInnerHTML={{
                                            __html: location.state.test
                                                .instructionsTemplate,
                                        }}
                                    />
                                )}
                            </div>
                            <DisplayButton
                                buttons={[
                                    (
                                        (location.state.test.testExample !== null && !location.state.previewData)   // Main test: show if testExample exists
                                        ||
                                        (location.state.previewData && location.state.test.testExample === null && !location.state.isNotExampleTest)    // Preview: only example test
                                        ||
                                        (location.state.previewData && location.state.test.testExample !== null) // Preview: having both example + main
                                    ) && (
                                        <button
                                            className="button-secondary text_uppercase mt2 full-width_mobile"
                                            onClick={() => (location.state.previewData && location.state.test.testExample == null) ? handleButtonClick() : handleButtonClick(true)}
                                        >
                                            {location.state.test.testType === 9
                                                ? phrases?.["10980"]
                                                : phrases?.["1000253"]}
                                        </button>
                                    ), (
                                    !location.state.previewData //Main TEST: Acutal test from session
                                    ||
                                    (location.state.previewData && location.state.test.testExample === null && location.state.isNotExampleTest)	// Preview: contains only main test
                                    ||
                                    (location.state.previewData && location.state.test.testExample !== null)    // Preview: having both example + main
                                )  && (
                                    <button
                                        className="button-primary text_uppercase mt2 full-width_mobile"
                                        disabled={setAssesmentDisable()}
                                        onClick={handleStart}
                                    >
                                        {location.state.test.testType === 9
                                            ? phrases?.["11070"]
                                            : phrases?.["15207"]}
                                        <span className="material-icons-outlined">
                                            east
                                        </span>
                                    </button>)]} />
                        </>
                    )}
                </>
            )}
        </>
    );
};

export default Instructions;
